import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function CtaSection() {
  const { t } = useTranslation();

  return (
    <div className="bg-[#101829] py-24">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl mb-6">
          {t('cta.title')} <span className="text-[#8B5CF6]">{t('cta.titleHighlight')}</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/onboarding/saas"
          className="inline-flex items-center px-8 py-4 bg-[#8B5CF6] hover:bg-[#9D72F7] text-white text-lg font-medium rounded-lg transition-colors"
        >
          {t('cta.button')}
          <ArrowRight className="ml-2 h-5 w-5" />
        </Link>
      </div>
    </div>
  );
}
